<template>
  <card style="width: 100%">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="5">
        <!--  SELECT !-->
        <el-select
          class="select-default"
          v-model="itemsPerPage"
          placeholder="Per page"
        >
          <el-option
            class="select-default"
            v-for="item in pageOptions"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-col>
      <el-col :span="14" class="table-extras">
        <slot name="extras" />
      </el-col>
      <el-col :span="5">
        <!--  SEARCH !-->
        <slot name="search" />
      </el-col>
    </el-row>
    <!--  TABLE !-->
    <el-table
      :data="rows"
      stripe
      border
      style="width: 100%"
    >
      <slot name="default" />
    </el-table>
    <br>
    <!--  PAGINATION !-->
    <p-pagination
      class="pull-right"
      v-model="currentPage"
      :per-page="itemsPerPage"
      :page-count="lastPage"
      @input="handlePageChanged"
    />
  </card>
</template>

<script>
import { mapState, mapActions, vuex } from 'vuex';
import Pagination from '../UIComponents/Pagination';
import PaginationStoreModule from '../../store/modules/Pagination/index';

export default {
    name: 'RPaginatedSearchTable',
    components: {
        [Pagination.name]: Pagination,
    },
    data() {
        return {

        };
    },
    props: {
        data: {
            type: Array,
            default: () => [],
            description: 'Table Data'
        },
        parentNamespace: {
            type: String,
            default: '',
            required: true
        },
        pageSizeOptions: {
            type: Array,
            default: () => [10, 50, 100, 150]
        }
    },
    computed: {
        rows() { return this.data; },
        // vuex mapState can't access props so we have to do this the long way
        currentPage: {
            get() {
                return this.$store.state[this.parentNamespace].Pagination.currentPage;
            },
            set(newPage) {
                this.$store.commit(`${this.parentNamespace}/Pagination/setCurrentPage`, newPage);
            }
        },
        lastPage() {
            return this.$store.state[this.parentNamespace].Pagination.lastPage;
        },
        pageOptions() {
            return this.$store.state[this.parentNamespace].Pagination.pageOptions;
        },
        itemsPerPage: {
            get() {
                return this.$store.state[this.parentNamespace].Pagination.itemsPerPage;
            },
            set(newItemsPerPage) {
                this.$store.commit(`${this.parentNamespace}/Pagination/setItemsPerPage`, newItemsPerPage);
                this.$emit('updateTable');
            }

        }
    },
    methods: {
        handlePageChanged(newPage) {
            this.currentPage = newPage;
            this.$emit('updateTable');
        },
    },
    created() {
        this.$store.commit(`${this.parentNamespace}/Pagination/setPageOptions`, this.pageSizeOptions);
    },
    beforeDestroy() {
        // todo destroy the pagination state.
    }
};
</script>
